function update_url(resp) {
    if (window.history && "pushState" in window.history) {
        const url = resp.data.data.url;
        if (!url) return;
        window.history.pushState(null, "", url);
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = url;
        }
    }
}
function groupBy(objectArray, property, value) {
    return objectArray.reduce(function (acc, obj) {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj[value]);
        return acc;
    }, {});
}
function getFormData(filter_form) {
    let formData = new FormData(filter_form);
    let object = [];
    formData.forEach(function (value, key) {
        const o = {
            name: key,
            value: value,
        };
        object.push(o);
    });
    const pieces = groupBy(object, "name", "value");
    formData = new FormData();
    for (const piece in pieces) {
        if (pieces.hasOwnProperty(piece)) {
            formData.append(piece, pieces[piece].join("|"));
        }
    }
    return formData;
}
function oiFilterDisableForm(oi_filter_form) {
    if (oi_filter_form) {
        let i;
        // Disable all form inputs
        for (i = 0; i < oi_filter_form.elements.length; i++) {
            oi_filter_form.elements[i].setAttribute("disabled", "disabled");
        }
        // Disable all elements with class of "oi-disable-while-pending"
        const to_disable = document.getElementsByClassName(
            "oi-disable-while-pending"
        );
        for (i = 0; i < to_disable.length; i++) {
            to_disable[i].setAttribute("disabled", "disabled");
        }
        // Reduce the opacity of all elements with class of "model-filters"
        // ?? Can we just do this for all elements inside the form ??
        const model_filters = document.getElementsByClassName("model-filters");
        for (i = 0; i < model_filters.length; i++) {
            model_filters[i].style.opacity = "0.6";
        }
        // ?? What about an overlay and spinner ??
    }
}
function oiFilterEnableForm(oi_filter_form) {
    if (oi_filter_form) {
        setTimeout(function () {
            let i;
            // Remove the disabled attribute and value from inputs.
            for (i = 0; i < oi_filter_form.elements.length; i++) {
                oi_filter_form.elements[i].disabled = false;
                oi_filter_form.elements[i].removeAttribute("disabled");
            }
            // Remove disabled from all elements with class of "oi-disable-while-pending"
            const to_disable = document.getElementsByClassName(
                "oi-disable-while-pending"
            );
            for (i = 0; i < to_disable.length; i++) {
                to_disable[i].disabled = false;
                to_disable[i].removeAttribute("disabled");
            }
            // Reset the opacity of all elements with class of "model-filters"
            const model_filters =
                document.getElementsByClassName("model-filters");
            for (i = 0; i < model_filters.length; i++) {
                model_filters[i].style.opacity = "1";
            }
        }, 500);
    }
}
function oiFilterAjaxBeforesend(oi_filter_form, from_infinite) {
    if (from_infinite === undefined || from_infinite === false) {
        oiFilterDisableForm(oi_filter_form);
    }
}
function oiFilterGetResults(oi_filter_form, results) {
    const ftype = oi_filter_form.dataset.filterType;
    const url = `/xhr/filter/${ftype}/`;
    const formData = getFormData(oi_filter_form);
    oi.axios({
        method: "post",
        url: url,
        data: formData,
        headers: {
            "Content-Type": "application/json",
        },
        transformRequest: [
            function (data, headers) {
                // We're not really transforming the request, but this function runs
                // before the ajax posts.
                oiFilterAjaxBeforesend(oi_filter_form, false);
                // We let the data pass-through unchanged.
                return data;
            },
        ],
    })
        .then(function (resp) {
            if (resp.data.data.result_list) {
                if (resp.data.options) {
                    const options = resp.data.options;
                    for (const id in options) {
                        document.getElementById(option).innerHTML =
                            options[option];
                    }
                }
                if (resp.data.paginator && resp.data.paginator !== "") {
                    const pageinput =
                        oi_filter_form.querySelector('input[name="page"]');
                    pageinput.value = resp.data.paginator.next;
                }
                results.innerHTML = resp.data.data.result_list;
                // Keep the HOMES count badge(s) in sync with the filtered result
                // count. There are two badges (desktop + mobile), so target the
                // class, not an id. Check against undefined (not truthiness) so a
                // legitimate 0-result count still updates the badge.
                if (resp.data.data.amount !== undefined) {
                    document
                        .querySelectorAll(".oi-filter-amount")
                        .forEach((badge) => {
                            badge.innerHTML = resp.data.data.amount;
                        });
                }
                if (resp.data.map_items && resp.data.map_items !== "") {
                    const map_items =
                        document.querySelector(".oi-all-map-items");
                    map_items.innerHTML = resp.data.map_items;
                }
                update_url(resp);
                if (window.afterResultsSuccess !== undefined) {
                    window.afterResultsSuccess();
                }
                // ?? This appears to be formatted for maps pre-oilib ??
                if (oi && oi.loaded && oi.loaded.map && oi.loaded.map['oi-map']) {
                    oi.loaded.map['oi-map'].set_markers(ftype);
                    oi.loaded.map['oi-map'].fit();
                }
            }
        })
        .catch(function (error) {
            if (error.response) {
                if (error.response.status == 400) {
                    let msg = "";
                    const errors = error.response.data.errors;
                    for (let err in errors) {
                        let x = errors[err];
                        msg = `${x.code} - ${x.description}\n`;
                    }
                    oiFilterEnableForm(oi_filter_form);
                } else if (error.response.status == 302) {
                    // Redirecting
                    window.location.href = error.response.data.data.redirect;
                }
            } else if (error.request) {
                console.error(error.request);
            } else {
                console.error(error.message);
            }
        })
        .then(function () {
            const name_input = oi_filter_form.querySelector('input[name="m"]');
            if (name_input !== null) {
                name_input.value = "0";
            }
            oiFilterEnableForm(oi_filter_form);
        });
}
// Sentinel used by the range filters: an empty Max means "no upper bound".
const FILTER_HIGH_VALUE = 999999999;
// Assemble a `%min-max` range value from a Min and Max <select>. Empty Min
// becomes 0, empty Max becomes the high sentinel; both empty clears the filter.
function assembleRangeValue(minSelect, maxSelect) {
    const min = minSelect && minSelect.value ? minSelect.value : "";
    const max = maxSelect && maxSelect.value ? maxSelect.value : "";
    if (!min && !max) {
        return "";
    }
    return `%${min || 0}-${max || FILTER_HIGH_VALUE}`;
}
// Hide the Bootstrap dropdown that contains the given button (the panels use
// data-bs-auto-close="outside" so they stay open while the user picks values).
function closeFilterDropdown(button) {
    const dropdown = button.closest(".dropdown");
    if (!dropdown) {
        return;
    }
    const toggle = dropdown.querySelector('[data-bs-toggle="dropdown"]');
    if (toggle && window.bootstrap) {
        window.bootstrap.Dropdown.getOrCreateInstance(toggle).hide();
    }
}
// Compact price for a pill label: 300000 -> "$300K", 1250000 -> "$1.25M".
function formatPricePill(value) {
    const number = parseInt(value, 10);
    if (!number) {
        return "";
    }
    if (number >= 1000000) {
        const millions = number / 1000000;
        // Trim trailing zeros so 1000000 reads "$1M", 1250000 reads "$1.25M".
        return "$" + parseFloat(millions.toFixed(2)) + "M";
    }
    if (number >= 1000) {
        return "$" + Math.round(number / 1000) + "K";
    }
    return "$" + number;
}
// Square-footage value with thousands separators: 2000 -> "2,000".
function formatSqftPill(value) {
    const number = parseInt(value, 10);
    return number ? number.toLocaleString("en-US") : "";
}
// Build a "min - max" pill label from a hidden `%min-max` range value. An empty
// (0) min reads "No Min"; the high sentinel max reads "No Max". Returns "" when
// neither bound is set so the pill falls back to its default name.
function rangePillLabel(rawValue, formatter) {
    if (!rawValue) {
        return "";
    }
    const [minRaw, maxRaw] = rawValue.replace(/^%/, "").split("-");
    const hasMin = minRaw && minRaw !== "0";
    const hasMax = maxRaw && maxRaw !== String(FILTER_HIGH_VALUE);
    if (!hasMin && !hasMax) {
        return "";
    }
    const minText = hasMin ? formatter(minRaw) : "No Min";
    const maxText = hasMax ? formatter(maxRaw) : "No Max";
    return `${minText} - ${maxText}`;
}
// Build the "Beds & Baths" pill label from the hidden bedrooms (@N gte / =N exact)
// and bathrooms (@N gte) values. Exact-match beds drop the "+" (e.g. "5 Beds"
// instead of "5+ Beds"); bathrooms are always gte.
function bedsBathsPillLabel(bedsRaw, bathsRaw) {
    const parts = [];
    if (bedsRaw) {
        const isExact = bedsRaw.charAt(0) === "=";
        const count = bedsRaw.slice(1);
        if (count) {
            parts.push(`${count}${isExact ? "" : "+"} Beds`);
        }
    }
    if (bathsRaw) {
        const count = bathsRaw.slice(1);
        if (count) {
            parts.push(`${count}+ Baths`);
        }
    }
    return parts.join(", ");
}
// Build the Price pill label. The hidden #oi-filter-price always stores the
// equivalent *list* price (so the filter works the same from either tab), but
// when the user picked on the Monthly tab the pill should show the monthly
// figures they actually selected. So if the Monthly pane is active and has a
// selection, read the selected options' visible text (e.g. "$1,000 - $2,000/mo");
// otherwise fall back to the list-price range from the hidden value.
function pricePillLabel() {
    const monthlyPane = document.getElementById("price-monthly");
    if (monthlyPane && monthlyPane.classList.contains("active")) {
        const minSelect = monthlyPane.querySelector(".oi-price-min");
        const maxSelect = monthlyPane.querySelector(".oi-price-max");
        const hasMin = minSelect && minSelect.value;
        const hasMax = maxSelect && maxSelect.value;
        if (hasMin || hasMax) {
            // The empty options read "No Min" / "No Max", so the option text works
            // directly for both real selections and the unbounded placeholders.
            const minText = minSelect ? minSelect.options[minSelect.selectedIndex].text : "No Min";
            const maxText = maxSelect ? maxSelect.options[maxSelect.selectedIndex].text : "No Max";
            return `${minText} - ${maxText}/mo`;
        }
    }
    const priceInput = document.getElementById("oi-filter-price");
    return rangePillLabel(priceInput ? priceInput.value : "", formatPricePill);
}
// Write a computed label into a pill (or its default name when no selection),
// and flag the button so an active filter can be styled.
function setPillLabel(spanId, text, fallback) {
    const span = document.getElementById(spanId);
    if (!span) {
        return;
    }
    span.textContent = text || fallback;
    const button = span.closest(".dropdown-toggle");
    if (button) {
        button.classList.toggle("oi-filter-pill-active", !!text);
    }
}
// Refresh all desktop filter pills from the hidden #oi-filter-* values (the
// single source of truth). Called on load, after each Apply, and after reset.
function updateFilterPillLabels() {
    const sqftInput = document.getElementById("oi-filter-sqft");
    const bedsInput = document.getElementById("oi-filter-bedrooms");
    const bathsInput = document.getElementById("oi-filter-bathrooms");
    // Price and Square Feet are Min/Max range filters. Once either bound is set the pill
    // reads as a range, with the unselected side showing its "No Min" / "No Max"
    // placeholder (e.g. "1,000 - No Max"). With nothing selected the pill keeps its plain
    // filter name ("Price" / "Square Feet").
    setPillLabel("oi-pill-price", pricePillLabel(), "Price");
    setPillLabel("oi-pill-sqft", rangePillLabel(sqftInput ? sqftInput.value : "", formatSqftPill), "Square Feet");
    setPillLabel(
        "oi-pill-beds",
        bedsBathsPillLabel(bedsInput ? bedsInput.value : "", bathsInput ? bathsInput.value : ""),
        "Beds & Baths"
    );
}
// On a full page load of a filtered URL, mirror the hidden #oi-filter-* values
// back onto the dropdown panels so the controls show the active selection.
function restoreFilterPanelState() {
    const price = document.getElementById("oi-filter-price");
    if (price && price.value) {
        const [min, max] = price.value.replace(/^%/, "").split("-");
        const minSelect = document.querySelector("#price-list .oi-price-min");
        const maxSelect = document.querySelector("#price-list .oi-price-max");
        if (minSelect && min && min !== "0") {
            minSelect.value = min;
        }
        if (maxSelect && max && max !== String(FILTER_HIGH_VALUE)) {
            maxSelect.value = max;
        }
    }
    const sqft = document.getElementById("oi-filter-sqft");
    if (sqft && sqft.value) {
        const [min, max] = sqft.value.replace(/^%/, "").split("-");
        const minSelect = document.querySelector(".oi-sqft-min");
        const maxSelect = document.querySelector(".oi-sqft-max");
        if (minSelect && min && min !== "0") {
            minSelect.value = min;
        }
        if (maxSelect && max && max !== String(FILTER_HIGH_VALUE)) {
            maxSelect.value = max;
        }
    }
    const beds = document.getElementById("oi-filter-bedrooms");
    if (beds && beds.value) {
        const bedsRadio = document.querySelector(`.oi-beds-option[value="${beds.value.slice(1)}"]`);
        if (bedsRadio) {
            bedsRadio.checked = true;
        }
        const exact = document.querySelector(".oi-beds-exact");
        if (exact) {
            exact.checked = beds.value.charAt(0) === "=";
        }
    }
    const baths = document.getElementById("oi-filter-bathrooms");
    if (baths && baths.value) {
        const bathsRadio = document.querySelector(`.oi-baths-option[value="${baths.value.slice(1)}"]`);
        if (bathsRadio) {
            bathsRadio.checked = true;
        }
    }
    updateFilterPillLabels();
}
window.addEventListener("load", () => {
    const oi_filter_form = document.getElementById("oi-filter-form");
    if (oi_filter_form) {
        // Query document-wide, not just within the form: offcanvas filter
        // inputs (home type, stories, first-floor toggle) sit outside the form
        // and associate via the form="oi-filter-form" attribute.
        const oi_filter_clickables =
            document.querySelectorAll(".oi-filter-click");
        const oi_filter_changables =
            document.querySelectorAll(".oi-filter-change");
        oi_filter_clickables.forEach((elem) => {
            elem.addEventListener("click", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });
        oi_filter_changables.forEach((elem) => {
            elem.addEventListener("change", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });
        // Sort proxies. The visible "Sort by" <select>s (desktop bar + mobile
        // offcanvas, class oi-sort-select) are UI only. The single field posted
        // as "sort" is the hidden #oi-sort-input (oi-filter-change, inside the
        // form). On load each visible select syncs to the hidden input's
        // server-rendered value; on change it copies its value onto the hidden
        // input and dispatches a change there, which the oi-filter-change handler
        // above catches and re-fetches results. One named "sort" field means a
        // single interaction never posts two sort values.
        const oi_sort_input = document.getElementById("oi-sort-input");
        document.querySelectorAll(".oi-sort-select").forEach((oi_sort_select) => {
            if (oi_sort_input) {
                oi_sort_select.value = oi_sort_input.value;
            }
            oi_sort_select.addEventListener("change", (e) => {
                if (!oi_sort_input) {
                    return;
                }
                oi_sort_input.value = e.target.value;
                oi_sort_input.dispatchEvent(new Event("change"));
            });
        });
        // Filter dropdown "Apply" buttons. Each panel stages its values in
        // plain (un-named) controls; Apply assembles them into the hidden
        // #oi-filter-* inputs (which carry the real filter names) and triggers
        // the same AJAX post used by the inline change handlers above.
        const oi_filter_apply = document.querySelectorAll(".oi-filter-apply");
        oi_filter_apply.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                const panel = btn.closest(".dropdown-menu") || document;
                const kind = btn.dataset.apply;
                if (kind === "price") {
                    // Read whichever tab (List Price / Monthly) is active; both
                    // carry list-price values, so the result is always a price range.
                    const pane = panel.querySelector(".tab-pane.active") || panel;
                    document.getElementById("oi-filter-price").value = assembleRangeValue(
                        pane.querySelector(".oi-price-min"),
                        pane.querySelector(".oi-price-max")
                    );
                } else if (kind === "sqft") {
                    document.getElementById("oi-filter-sqft").value = assembleRangeValue(
                        panel.querySelector(".oi-sqft-min"),
                        panel.querySelector(".oi-sqft-max")
                    );
                } else if (kind === "beds") {
                    const bedsOption = panel.querySelector(".oi-beds-option:checked");
                    const exact = panel.querySelector(".oi-beds-exact");
                    // Exact match swaps gte (@N) for exact (=N); see filters.py.
                    document.getElementById("oi-filter-bedrooms").value =
                        bedsOption && bedsOption.value
                            ? (exact && exact.checked ? "=" : "@") + bedsOption.value
                            : "";
                    const bathsOption = panel.querySelector(".oi-baths-option:checked");
                    document.getElementById("oi-filter-bathrooms").value =
                        bathsOption && bathsOption.value ? "@" + bathsOption.value : "";
                }
                updateFilterPillLabels();
                closeFilterDropdown(btn);
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });
        restoreFilterPanelState();
        // Prevent contradictory or no-op range selections (e.g. Min $500K with
        // Max $300K, or Min $300K with Max $300K). For each Min/Max <select> pair,
        // disable Max options at or below the chosen Min and Min options at or above
        // the chosen Max, so the only selectable ranges have Max strictly greater
        // than Min. Runs after restoreFilterPanelState so the initial pass respects
        // values restored from the filter hash.
        function constrainRangePair(minSelect, maxSelect) {
            if (!minSelect || !maxSelect) {
                return;
            }
            const sync = () => {
                const minVal = minSelect.value ? parseInt(minSelect.value, 10) : null;
                const maxVal = maxSelect.value ? parseInt(maxSelect.value, 10) : null;
                Array.from(maxSelect.options).forEach((opt) => {
                    // Keep the empty "No Max"; disable any cap at or below the chosen
                    // floor. Using <= (not <) also blocks the no-op Min == Max range.
                    opt.disabled = opt.value !== "" && minVal !== null && parseInt(opt.value, 10) <= minVal;
                });
                Array.from(minSelect.options).forEach((opt) => {
                    // Keep the empty "No Min"; disable any floor at or above the chosen
                    // cap. Using >= (not >) keeps Min strictly below Max (no no-op range).
                    opt.disabled = opt.value !== "" && maxVal !== null && parseInt(opt.value, 10) >= maxVal;
                });
            };
            minSelect.addEventListener("change", sync);
            maxSelect.addEventListener("change", sync);
            sync();
        }
        // Price has two tabs (List Price / Monthly), each its own min/max pair in a
        // .tab-pane; square footage has a single pair in its panel. Query every
        // instance so both desktop dropdowns and the mobile offcanvas are wired.
        document.querySelectorAll(".oi-price-min").forEach((minSelect) => {
            const pane = minSelect.closest(".tab-pane") || minSelect.closest(".dropdown-price") || document;
            constrainRangePair(minSelect, pane.querySelector(".oi-price-max"));
        });
        document.querySelectorAll(".oi-sqft-min").forEach((minSelect) => {
            const panel = minSelect.closest(".dropdown-sqft") || minSelect.closest(".dropdown-menu") || document;
            constrainRangePair(minSelect, panel.querySelector(".oi-sqft-max"));
        });
        // Reset buttons can live outside the <form> (empty-results card, offcanvas
        // footer), so query the whole document instead of the form.
        const oi_filter_reset = document.querySelectorAll(".oi-filter-reset");
        const oi_filter_results = document.getElementById("oi-filter-results");
        if (oi_filter_reset !== null && oi_filter_results !== null) {
            oi_filter_reset.forEach((btn) => {
                btn.addEventListener("click", (e) => {
                    let i;
                    e.preventDefault();
                    const to_clear =
                        document.getElementsByClassName("oi-clear-on-reset");
                    if (to_clear) {
                        for (i = 0; i < to_clear.length; i++) {
                            if (to_clear[i].type == "select-one") {
                                to_clear[i].selectedIndex = 0;
                            }
                            // Hidden sort proxy: clear back to the default (no
                            // sort). Its visible <select>s are reset by the
                            // select-one branch above; this clears the one field
                            // actually posted so the refetch returns to default order.
                            if (to_clear[i].id == "oi-sort-input") {
                                to_clear[i].value = "";
                            }
                            if (to_clear[i].id == "boyl-input") {
                                to_clear[i].value = false;
                            }
                            if (to_clear[i].type == "checkbox") {
                                to_clear[i].checked = false;
                            }
                            // Offcanvas radio groups (Stories, Garages, Home
                            // Direction) reset to their "Any" option, which is the
                            // one with an empty value.
                            if (to_clear[i].type == "radio") {
                                to_clear[i].checked = to_clear[i].value === "";
                            }
                        }
                    }
                    const buttons_to_reset =
                        document.getElementsByClassName("filter-button-on");
                    if (buttons_to_reset) {
                        for (i = 0; i < buttons_to_reset.length; i++) {
                            buttons_to_reset[i].classList.remove(
                                "filter-button-on"
                            );
                        }
                    }
                    // Clear the dropdown filter panels: blank the hidden values,
                    // reset Min/Max selects, return beds/baths to "Any", untick exact.
                    document.querySelectorAll(".oi-filter-value").forEach((input) => {
                        input.value = "";
                    });
                    document
                        .querySelectorAll(".oi-price-min, .oi-price-max, .oi-sqft-min, .oi-sqft-max")
                        .forEach((select) => {
                            select.selectedIndex = 0;
                            // Re-enable any options constrainRangePair disabled so
                            // the full Min/Max ranges are selectable again.
                            Array.from(select.options).forEach((opt) => {
                                opt.disabled = false;
                            });
                        });
                    document
                        .querySelectorAll(".oi-beds-option, .oi-baths-option")
                        .forEach((radio) => {
                            radio.checked = radio.value === "";
                        });
                    document.querySelectorAll(".oi-beds-exact").forEach((box) => {
                        box.checked = false;
                    });
                    // Return the All / Quick Move-ins / Model Homes scope toggle to
                    // its "All Results" default on a filter reset.
                    document.querySelectorAll(".oi-restype").forEach((radio) => {
                        radio.checked = radio.value === "all";
                    });
                    updateFilterPillLabels();
                    // Clear All returns the user to the unfiltered base URL.
                    // The AJAX filter appends a /filter/<hash>/ segment to the
                    // path (and pushState swaps it into the address bar), so a
                    // bare reset would otherwise leave them on a stale filtered
                    // permalink. Strip that segment and, when present, navigate
                    // there (a clean unfiltered load). If already on the base URL
                    // (the user opened the panel without filtering), just refresh
                    // results in place.
                    const baseUrl = window.location.pathname.replace(
                        /filter\/[0-9a-fA-F]+\/$/,
                        ""
                    );
                    if (baseUrl !== window.location.pathname) {
                        window.location.href = baseUrl;
                    } else {
                        oiFilterGetResults(oi_filter_form, oi_filter_results);
                    }
                });
            });
        }
    }
    // This function OVERWRITES the default onpopstate behavior, which is perhaps desireable.
    // If overwriting is not necessary, the alternate function below is more desirable, as
    // it ADDS functiontionality.
    // window.onpopstate = function (event) {
    //     location.reload();
    // }
    let pathName = document.location.pathname;
    window.addEventListener("popstate", (e) => {
        if (pathName === e.target.location.pathname) {
            return false;
        }
        location.reload();
    });
});
